import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { Toaster } from "react-hot-toast";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import "./i18n";
import TermsAndConditions from "./TermsAndConditions";
import App from "./app";
import FooterComponent from "./Components/Footer/FooterComponent";
import ChooseVehicle from "./Reservation/ChooseVehicle";
import ReservationCheckout from "./Reservation/ReservationCheckout";
import FAQ from "./FAQ";
import Layout from "./Layout";
import AdminApp from "./Admin/AdminApp";
import Blog from "./Blog";
import BlogPost from "./BlogPost";
import AboutPage from "./AboutPage";
import FleetPage from "./FleetPage";
import ContactsPage from "./ContactsPage";

const AppRoutes = () => {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  return (
    <>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/admin/*" element={<AdminApp />} />
        <Route element={<Layout />}>
          <Route path="/about" element={<AboutPage />} />
          <Route path="/fleet" element={<FleetPage />} />
          <Route path="/contacts" element={<ContactsPage />} />
          <Route path="/termsAndConditions" element={<TermsAndConditions />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/chooseVehicle" element={<ChooseVehicle />} />
          <Route path="/reservationCheckout" element={<ReservationCheckout />} />
          <Route path="/reservationCheckout/:step" element={<ReservationCheckout />} />
        </Route>
      </Routes>
      {!isAdmin && <FooterComponent />}
    </>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Toaster position="top-center" />
    <Router>
      <AppRoutes />
    </Router>
  </React.StrictMode>,
);

reportWebVitals();
